import React from "react"
import moment from "moment"
import { notification } from "antd"
import api from "src/api"
import { buildPeriodQuery } from "./query"

export const getDefaultPeriod = (source) => ({
  dateFrom: moment().subtract(29, "days").format("YYYY-MM-DD"),
  dateTo: moment().format("YYYY-MM-DD"),
  source,
  group: "day",
  categories: [],
})

function errorMessage(error, fallback) {
  return error?.response?.data?.message || fallback
}

// Начисления и списания за период. source: sent — наши операции (+ «сегодня» с очередью),
// tillypad — история Tillypad по типам операций.
export function usePointsReport(source) {
  const [period, setPeriod] = React.useState(() => getDefaultPeriod(source))
  const [report, setReport] = React.useState(null)
  const [today, setToday] = React.useState(null)
  const [categories, setCategories] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [isTodayLoading, setIsTodayLoading] = React.useState(false)

  React.useEffect(() => {
    api
      .get("bonus-points/categories", { useV2Api: true })
      .then(({ data }) => setCategories((data.items ?? []).filter((item) => item.source === source)))
      .catch(() => setCategories([]))
    loadReport(period)
    if (source === "sent") loadToday()
  }, [])

  function loadReport(nextPeriod) {
    setIsLoading(true)
    api
      .get(`bonus-points/daily?${buildPeriodQuery(nextPeriod)}`, { useV2Api: true })
      .then(({ data }) => setReport(data))
      .catch((error) => {
        notification.error({ message: "Не удалось загрузить отчёт", description: errorMessage(error) })
      })
      .finally(() => setIsLoading(false))
  }

  function loadToday() {
    setIsTodayLoading(true)
    api
      .get("bonus-points/today", { useV2Api: true })
      .then(({ data }) => setToday(data))
      .catch(() => setToday(null))
      .finally(() => setIsTodayLoading(false))
  }

  function handleSearch(nextPeriod) {
    const withSource = { ...nextPeriod, source }
    setPeriod(withSource)
    loadReport(withSource)
  }

  return {
    period,
    report,
    today,
    categories,
    isLoading,
    isTodayLoading,
    handleSearch,
    refreshToday: loadToday,
    exportQuery: () => buildPeriodQuery(period),
  }
}
